export class CheckUser {
    userId: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/registeration/check-user.ts